'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var AnchorFilter = function AnchorFilter($state) {

    return function (id) {
        return '/#' + $state.current.url + '#' + id;
    };
};

AnchorFilter.$inject = ['$state'];

exports.default = AnchorFilter;


// WEBPACK FOOTER //
// ./src/busqueda/filtros/anchor.filter.js